import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { navLinks, profile } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAF5EF]/90 backdrop-blur-md shadow-[0_1px_20px_rgba(58,48,42,0.06)] py-3"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <a href="#accueil" onClick={(e) => go(e, "#accueil")} className="flex flex-col leading-none">
          <span className="font-script text-2xl md:text-3xl text-[#B0603F]">{profile.brand}</span>
          <span className="font-body text-[10px] tracking-luxe text-[#6B5D53] uppercase mt-0.5">
            {profile.roleShort}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              className="relative font-body text-sm tracking-wide-2 uppercase text-[#3A302A] hover:text-[#B0603F] transition-colors duration-300 group"
            >
              {l.label}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-[#B0603F] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          onClick={(e) => go(e, "#contact")}
          className="hidden md:inline-flex items-center px-5 py-2.5 rounded-full bg-[#3A302A] text-[#FAF5EF] text-xs tracking-wide-2 uppercase hover:bg-[#B0603F] transition-colors duration-300"
        >
          Collaborer
        </a>

        <button className="md:hidden text-[#3A302A]" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ${
          open ? "max-h-96 mt-4" : "max-h-0"
        }`}
      >
        <nav className="bg-[#FAF5EF]/95 backdrop-blur-md px-6 py-4 flex flex-col gap-4">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              className="font-body text-base tracking-wide-2 uppercase text-[#3A302A] hover:text-[#B0603F]"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
